/**
 * Analytics event name constants
 * 
 * This file contains standardized event names and categories for Plausible Analytics.
 * Use these constants when tracking events to ensure consistency.
 */

// Page view events
export const PAGE_VIEW = 'pageview';
export const PAGE_NOT_FOUND = '404';

// User interaction events
export const BUTTON_CLICK = 'Button Click';
export const LINK_CLICK = 'Link Click';
export const FORM_SUBMIT = 'Form Submit';
export const VIDEO_PLAY = 'Video Play';
export const VIDEO_PAUSE = 'Video Pause';
export const VIDEO_COMPLETE = 'Video Complete';

// Specific action events
export const NEWSLETTER_SUBSCRIBE = 'Newsletter Subscription';
export const DISCORD_JOIN = 'Discord Join';
export const FEATURE_EXPLORE = 'Feature Explore';

// Categories
export const CATEGORIES = {
  HERO: 'Hero Section',
  STORY: 'Story Section',
  FEATURES: 'Features Section',
  FOOTER: 'Footer',
  NAV: 'Navigation'
};

/**
 * Helper function to create standardized props for Plausible events
 */
export const createEventProps = (category: string, action?: string, label?: string) => {
  const props: Record<string, string> = {
    category
  };
  
  if (action) props.action = action;
  if (label) props.label = label;
  
  return { props };
}; 